import { Form } from '@/components/contact'
import { useTranslation } from '@/utils/hook'

export function Banner(): JSX.Element {
  const t = useTranslation()
  return (
    <div className="bg-white py-24 px-4">
      <div className="max-w-5xl mx-auto">
        <h1 className="pageTitle">{t('contact.bannerHeadline')}</h1>
        <p className="pageDesc max-w-2xl mx-auto">
          {t('contact.bannerSubhead')}
        </p>

        <div className="mt-16">
          <Form />
        </div>
      </div>
    </div>
  )
}
